import { Component, OnInit } from '@angular/core';
import { SidenavService } from '../../services/sidenav/sidenav.service';
import { Router } from '@angular/router';
import { CVA_CONSTANTS } from '../../util/constants';

import { AUTH_MODULE_ROUTE_MAP, ROUTE_CONSTANTS } from '../../util/route.constants';
import { environment } from '../../../environments/environment';
import { HistoricalDataNaviItem } from '../../models/historical-data.interface';
import { HistoricalDataComponent } from '../historical-data/historical-data.component';
import { PatientAppointmentListComponent } from '../patient-appointment-list/patient-appointment-list.component';
import { MatDialog } from '@angular/material/dialog';
import { PractitionerService } from '../../services/practitioner/practitioner.service';
import { PatientSearchModalComponent } from '../patient-search-modal/patient-search-modal.component';

@Component({
    standalone: false,
    selector: 'cva-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrl: './side-nav.component.scss',
    
})
export class SideNavComponent implements OnInit {
  ROUTE_CONSTANTS = ROUTE_CONSTANTS;
  cvaUI_url = environment.cvaUI_url;

  title = 'CVA';

  navIsExpanded = false;

  isSideNavEnabled = true;

  profile = {
    img: '../../../assets/images/hall-connection-metal-physician-bright 1.png'
  };

  appScopes: {
    icon: string;
    title: string;
    route: string;
  }[] = CVA_CONSTANTS.NAVIGATION_BUTTONS;

  activeRoute = '/';

  historicalDataNavItems: HistoricalDataNaviItem[] = [];
  AUTH_MODULE_ROUTE_MAP = AUTH_MODULE_ROUTE_MAP;
  CVA_CONSTANTS = CVA_CONSTANTS;

  constructor(
    private readonly sidenavService: SidenavService,
    public router: Router,
    public dialog: MatDialog,
    public practitionerService: PractitionerService
  ) {
  }

  ngOnInit(): void {
    this.getSideNavStatus();

    this.sidenavService.isNavExpanded$.subscribe({
      next: (status) => (this.navIsExpanded = status),
    });
  }

  getSideNavStatus() {
    this.sidenavService
      .getRouterObservable()
      .subscribe({
        next: (sideNavInfo: { open: boolean; props: { route: string } }) => {
          this.isSideNavEnabled = sideNavInfo.open;
          this.activeRoute = sideNavInfo?.props?.route;
        },
      });
  }

  toggleNavbar() {
    this.sidenavService.toggleNavExpandedStatus();
  }

  onClickNavButton(
    scope: {
      icon: string;
      title: string;
      route: string;
    } | null
  ) {
    if (scope?.route) {
      if (scope.title == 'Patient Search') {
        this.dialog.open(PatientSearchModalComponent, {
          panelClass: 'custom-modalbox',
          width: '80vw',
          position: {
            top: '6vw',
            left: '10vw'
          }
        });
        return;
      }
      console.log("Side navigation entry clicked " + scope.title);
      this.router.navigate([scope.route]);
      this.activeRoute = scope.route;
    }
  }

  // this function will open common historical data modal
  openHistoricalDataModal(historicalDataNavItem: HistoricalDataNaviItem): void {
    const data: Record<string, string> = {
      patientId: localStorage.getItem('patientId') as string,
      category: historicalDataNavItem.category,
      title: historicalDataNavItem.title,
    };
    console.log("Opening historical data modal");
    this.dialog.open(HistoricalDataComponent, {
      height: '90%',
      width: '65vw',
      data,
      panelClass: 'custom-modalbox',
    });
  }

  openPatientAppointment(): void {
    const data: Record<string, string> = {
      patientId: localStorage.getItem('patientId') as string
    };
    console.log("Opening patient appointments modal");
    this.dialog.open(PatientAppointmentListComponent, {
      height: '90%',
      width: '65vw',
      data,
      panelClass: 'custom-modalbox',
    });
  }

  //This function is just to avoid SONAR warning
  doNothing() {
    console.log("Do nothing");
  }
}
